import { createTheme, PaletteOptions } from '@mui/material/styles';

export default createTheme({
  palette: {
    primary: {
      main: '#005C7E',
      light: '#005C7E1A',
      dark: '#182025',
      contrastText: '#fff',
    },
    secondary: {
      main: '#B0BEC5',
      light: '#1bc1f3',
      dark: '#5b73f3',
      contrastText: '#fff',
    },
    success: {
      main: '#219653',
      light: '#2196531A',
    },
    warning: {
      main: '#D57200',
      light: '#E891374D',
    },
    error: {
      main: '#D5000E',
      light: '#D5000E1A',
    },
    info: {
      main: '#2196F3',
      dark: '#5C6269',
      // Hex, NOT the keyword 'whitesmoke' (same color): MUI v6's Alert builds
      // its variant styles by running darken() over EVERY palette entry that
      // has main+light, and darken() rejects CSS keywords — so a keyword here
      // crashed any <Alert> rendered under this theme (VE-24948 surfaced it;
      // the stale-version warning banners were equally affected).
      light: '#F5F5F5',
      contrastText: '#CCEBFF',
    },
    processed: {
      main: '#D57200',
    },
  } as PaletteOptions,
  typography: {
    fontSize: 12,
  },
  components: {
    MuiSlider: {
      styleOverrides: {
        rail: {
          color: '#2196F3',
        },
      },
    },
  },
});

export const buttonTheme = createTheme({
  palette: {
    primary: {
      main: '#2196F3',
      light: '#1bc1f3',
      dark: '#1976d2',
      contrastText: '#fff',
    },
    secondary: {
      main: '#B0BEC5',
      light: '#1bc1f3',
      dark: '#1976d2',
      contrastText: '#CFD8DC',
    },
    text: {
      secondary: '#48555C',
    },
  },
});

export const tabsTheme = createTheme({
  palette: {
    primary: {
      main: '#F9A02C',
      light: '#f9d45f',
      dark: '#f99516',
      contrastText: '#fff',
    },
  },
});

export const folderTheme = createTheme({
  palette: {
    primary: {
      main: '#005C7E',
      light: '#005C7E1A',
      dark: '#004058',
      contrastText: '#FFF',
    },
    secondary: {
      main: '#000000',
      light: '#98AFC7',
      dark: '#004058',
      contrastText: '#FFF',
    },
    info: {
      main: '#00529B',
      light: '#BDE5F8',
      dark: '#48555C',
    },
    success: {
      main: '#4F8A10',
      light: '#DFF2BF',
    },
    warning: {
      main: '#9F6000',
      light: '#FEEFB3',
    },
    error: {
      main: '#D8000C',
      light: '#FFD2D2',
    },
  },
});
